import { render, staticRenderFns } from "./ModalAdminCustomerClassroomManagerAdd.vue?vue&type=template&id=377cde24&scoped=true&lang=pug&"
import script from "./ModalAdminCustomerClassroomManagerAdd.vue?vue&type=script&lang=ts&"
export * from "./ModalAdminCustomerClassroomManagerAdd.vue?vue&type=script&lang=ts&"
import style0 from "./ModalAdminCustomerClassroomManagerAdd.vue?vue&type=style&index=0&id=377cde24&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377cde24",
  null
  
)

export default component.exports